import React, { useEffect, useState, useRef } from "react";
import { WifiOutlined, WarningFilled } from "@ant-design/icons";
import { Row, Col } from "antd";

import "../../styles/App.css";

export const Offline = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [showRestored, setShowRestored] = useState(false);
  const wasOffline = useRef(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      if (wasOffline.current) {
        setShowRestored(true);
        setTimeout(() => setShowRestored(false), 4000);
      }
    };
    const handleOffline = () => {
      wasOffline.current = true;
      setOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (online && !showRestored) {
    return null;
  }

  return (
    <div className="offline-banner-container">
      {!online ? (
        <div className="offline-banner">
          <Row justify="center" align="middle">
            <Col xs={24} sm={20} md={16} lg={12} xl={8}>
              <div style={{ textAlign: "center" }}>
                <h4 style={{ margin: "8px 0" }}>
                  <WarningFilled /> You are offline!
                </h4>
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="online-banner">
          <Row justify="center" align="middle">
            <Col xs={24} sm={20} md={16} lg={12} xl={8}>
              <div style={{ textAlign: "center" }}>
                <h4 style={{ margin: "8px 0" }}>
                  <WifiOutlined /> Internet connection restored
                </h4>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};
